<template>
    <div class="modal modal-product-image-upload">
        <div class="wrapper" v-if="productIn">
            <div class="overlay_modal"></div>
            <div class="modal_ctn">
                <div class="modal_cerrar" @click="close">
                    <div class="mdi mdi-close"></div>
                </div>
                <h3>Producto: {{productIn.id}}</h3>
                <div class="modal_scroll">
                    <p style="text-align: center; margin-bottom: 20px;">{{productIn.description}}</p>
                    <file-pond
                        name="file"
                        ref="pond"
                        label-idle="Suelta tu archivo aquí..."
                        v-bind:allow-multiple="false"
                        :instantUpload="false"
                        accepted-file-types="image/png, image/jpeg"
                        labelFileProcessingComplete='Carga completada'
                        :allowImageValidateSize="true"
                        labelFileProcessing='Subiendo'
                        imageValidateSizeMinWidth="270"
                        imageValidateSizeMaxWidth="400"
                        imageValidateSizeMinHeight="270"
                        imageValidateSizeMaxHeight="400"
                        imageValidateSizeLabelImageSizeTooSmall="La imagen es muy pequeña"
                        imageValidateSizeLabelImageSizeTooBig="La imagen es muy grande"
                        imageValidateSizeLabelExpectedMinSize="Subir imagen de 270px de alto por 400px de ancho"
                        imageValidateSizeLabelExpectedMaxSize="Subir imagen de 270px de alto por 400px de ancho"
                        labelTapToCancel='Presiona para cancelar'
                        labelTapToRetry='Presiona para reintentar'
                        labelFileProcessingError='Error al cargar archivo'
                        :server="server"
                        v-bind:files="myFiles"/>
                </div>

            </div>
        </div>

    </div>
</template>
<script>

    import {AUTH_TOKEN} from "../../util/constants";
    import {paymentMethods} from '../../util/options'
    import vueFilePond from 'vue-filepond';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
    import alert from '../../util/alert';

    const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginImageValidateSize);

    export default {
        props: ['productIn'],
        components: {FilePond},
        data() {
            return {
                myFiles: [],
                server: {}
            }
        },
        watch: {
            productIn: function () {
                const self = this;
                if (self.productIn) {
                    self.server = {
                        url: `${process.env.SVC_URL}/product/${self.productIn.id}/image`,
                        process: {
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN)
                            },
                            onload: (response) => {
                                self.$emit("updated", JSON.parse(response).payload);
                                $(".modal-product-image-upload").removeClass("active");
                                alert.success("Imagen actualizada.");
                            },
                        },
                    }
                }
            }
        },
        computed: {},
        methods: {
            close() {
                $(".modal-product-image-upload").removeClass("active");
                self.$emit("closed");
            },
            getPaymentMethodStr(payMet) {
                const paymentMethod = paymentMethods.find((s) => s.key === payMet);
                return paymentMethod ? paymentMethod : {};
            },
        },
        mounted() {


        }
    }
</script>



// WEBPACK FOOTER //
// src/components/products/ProductImageUpload.vue